import { useMutation } from '@tanstack/react-query';

import { Space } from 'src/features/spaces/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/space/`;

type MutationFnType = typeof mutationFn;
interface DTO {
    parkingId: string;
}

const mutationFn = ({ parkingId, ...data }: DTO): Promise<Space> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateSpace };
